<template>
  <div class="animated fadeIn">
    <b-row v-for="(row, index) in rows" :key="index">
      <b-col
        v-for="(tileItem, index) in row"
        :key="index"
        align-self="center"
        class="mb-4"
      >
        <dashboard-tile :item="tileItem" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DashboardTile from "./DashboardTile";

export default {
  components: { DashboardTile },
  name: "DashboardTiles",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    rows() {
      const chunk = 4;
      let i,
        j,
        rows = [];
      for (i = 0, j = this.items.length; i < j; i += chunk) {
        rows = [...rows, this.items.slice(i, i + chunk)];
      }

      return rows;
    },
  },
};
</script>
